// dependencies.
import { get } from 'lodash'

// detect the base URL.
const appURL = get(process.env, 'APP_URL')

/**
 * detect the api base URL
 */
export default appURL



// WEBPACK FOOTER //
// ./src/plugins/http/appURL.js